
export default {
  '/': {
    tag: 'page-index',
  },
  '/:auth_mode(signin)': {
    tag: 'page-auth',
  },
  // Repro Incentive Operator
  '/admin/companies': {
    tag: 'page-companies',
  },
  '/admin/companies/:id': {
    tag: 'page-admin-companies-single',
  },
  '/admin/companies/:id/deposit_histories/:history_id/edit': {
    tag: 'page-admin-deposit_history-edit',
  },
  '/admin/companies/:id/deposit_histories/:history_id(new)': {
    tag: 'page-admin-deposit_history-edit',
  },
  '/admin/operators': {
    tag: 'page-operators',
  },
  '/admin/paypay_maintenances': {
    tag: 'page-admin-paypay_maintenances',
  },
  '/admin/paypay_maintenances/:id': {
    tag: 'page-admin-paypay_maintenances-single',
  },
  '/admin/nttcs_maintenances': {
    tag: 'page-admin-nttcs_maintenances',
  },
  '/admin/nttcs_maintenances/:id': {
    tag: 'page-admin-nttcs_maintenances-single',
  },
  '/admin/settings': {
    tag: 'page-settings',
  },
  '/admin/distribution-rules': {
    tag: 'page-admin-distribution-rules'
  },
  '/admin/companies/:company_id/projects/:project_id/campaigns/:campaign_id/distribution_rules/:distribution_rule_id': {
    tag: 'page-admin-distribution-rules-single',
  },
  // Client Operator
  '/app/companies/:company_id/projects': {
    tag: 'page-projects',
  },
  '/app/companies/:company_id/projects/:project_id?': {
    tag: 'page-projects-single',
  },
  '/app/companies/:company_id/projects/:project_id/edit': {
    tag: 'page-projects-single-edit',
  },
  '/app/companies/:company_id/projects/:project_id/members': {
    tag: 'page-members',
  },
  '/app/companies/:company_id/projects/:project_id/campaigns/:campaign_id': {
    tag: 'page-campaigns-single',
  },
  '/app/companies/:company_id/projects/:project_id/campaigns/:campaign_id/edit': {
    tag: 'page-campaigns-single-edit',
  },
  '/app/companies/:company_id/projects/:project_id/campaigns/:campaign_id/distribution_rules/:distribution_rule_id': {
    tag: 'page-distribution-rules-single',
  },
  '/app/companies/:company_id/projects/:project_id/campaigns/:campaign_id/distribution_rules/:distribution_rule_id/edit': {
    tag: 'page-distribution-rules-single-edit',
  },
  '/app/companies/:company_id/projects/:project_id/campaigns/:campaign_id/distribution_rules/:distribution_rule_id/webhooks/:webhook_id': {
    tag: 'page-distribution-rule-webhooks-single',
  },
  '/app/companies/:company_id': {
    tag: 'page-companies-single',
  },
  '/app/companies/:company_id/projects/:project_id/webhooks': {
    tag: 'page-webhooks',
  },
  '/app/companies/:company_id/projects/:project_id/webhooks/:webhook_id': {
    tag: 'page-webhooks-single',
  },
  '/app/companies/:company_id/deposit_histories': {
    tag: 'page-deposit_histories',
  },
  '/app/settings': {
    tag: 'page-settings',
  },
  // 未使用
  '/password-reset': {
    tag: 'page-password-reset',
  },
  '/debug': {
    tag: 'page-debug',
  },
};

